import { render, staticRenderFns } from "./CurrentShardList.vue?vue&type=template&id=7b2abad2&"
import script from "./CurrentShardList.vue?vue&type=script&lang=ts&"
export * from "./CurrentShardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports